import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth, homeFor } from "@/context/AuthContext";

export function FullPageLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="page-loader">
      <Loader2 className="h-7 w-7 animate-spin text-[#4F0341]" />
    </div>
  );
}

export default function ProtectedRoute({ roles, children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return <FullPageLoader />;
  if (!user) return <Navigate to={`/login?next=${encodeURIComponent(location.pathname)}`} replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to={homeFor(user)} replace />;
  return children;
}

export function GuestOnly({ children }) {
  const { user } = useAuth();
  if (user === null) return <FullPageLoader />;
  if (user) return <Navigate to={homeFor(user)} replace />;
  return children;
}
